import { TUI_FIRST_DAY, TUI_LAST_DAY } from "@taiga-ui/cdk";
import { EKwikUIInputDateRangeSize } from "./input-date-range.definitions";

export const DEFAULT_VALUES = {
  disabled: false,
  focus: false,
  formControlName: "form_control_input",
  hintContent: "",
  icon: "",
  id: "input",
  invalid: false,
  isShowLabelOutside: false,
  label: "Input",
  max: TUI_LAST_DAY,
  maxLength: null,
  min: TUI_FIRST_DAY,
  minLength: null,
  placeholder: "Please enter input",
  postfix: "",
  prefix: "",
  size: EKwikUIInputDateRangeSize.L
};

export const VALIDATE_KEY_VALUES = {
  disabled: true,
  focus: true,
  formControlName: true,
  hintContent: true,
  icon: true,
  id: true,
  invalid: true,
  isShowLabelOutside: true,
  label: true,
  max: true,
  maxLength: true,
  min: true,
  minLength: true,
  placeholder: true,
  postfix: true,
  prefix: true,
  size: true
};
